var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11686_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7258 21.3529H31.6323C31.9477 22.2162 32.1199 23.1479 32.1199 24.1189V35.8103C32.1199 36.2151 32.0495 36.6037 31.9212 36.9651H37.0354C38.9458 36.9651 40.4999 35.4109 40.4999 33.5006V27.1271C40.5 23.9432 37.9097 21.3529 34.7258 21.3529ZM8.88008 24.1189C8.88008 23.1479 9.05234 22.2163 9.36766 21.353H6.27422C3.09031 21.353 0.5 23.9433 0.5 27.1272V33.5007C0.5 35.4111 2.05414 36.9653 3.96453 36.9653H9.07875C8.94712 36.5944 8.87993 36.2038 8.88008 35.8103V24.1189ZM24.036 18.3447H16.964C13.7801 18.3447 11.1898 20.935 11.1898 24.1189V35.8103C11.1898 36.4481 11.7068 36.9652 12.3446 36.9652H28.6554C29.2932 36.9652 29.8102 36.4482 29.8102 35.8103V24.1189C29.8102 20.935 27.2199 18.3447 24.036 18.3447ZM20.5 3.03418C16.6709 3.03418 13.5558 6.14934 13.5558 9.97848C13.5558 12.5757 14.9893 14.8441 17.1063 16.035C18.1105 16.5999 19.2681 16.9227 20.5 16.9227C21.7319 16.9227 22.8895 16.5999 23.8937 16.035C26.0108 14.8441 27.4442 12.5757 27.4442 9.97848C27.4442 6.14941 24.3291 3.03418 20.5 3.03418ZM8.30609 9.50676C5.44242 9.50676 3.11273 11.8364 3.11273 14.7001C3.11273 17.5638 5.44242 19.8935 8.30609 19.8935C9.00981 19.8941 9.70623 19.7508 10.3526 19.4725C11.439 19.0048 12.3348 18.1768 12.8891 17.1397C13.2906 16.3893 13.5003 15.5512 13.4995 14.7001C13.4995 11.8365 11.1698 9.50676 8.30609 9.50676ZM32.6939 9.50676C29.8302 9.50676 27.5005 11.8364 27.5005 14.7001C27.4997 15.5512 27.7094 16.3893 28.1109 17.1397C28.6652 18.1769 29.561 19.0049 30.6474 19.4725C31.2938 19.7508 31.9902 19.8941 32.6939 19.8935C35.5576 19.8935 37.8873 17.5638 37.8873 14.7001C37.8873 11.8364 35.5576 9.50676 32.6939 9.50676Z",
    fill: "url(#paint0_linear_11686_2342)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_2342",
    x1: 5.52532,
    y1: 3.69937,
    x2: 37.5014,
    y2: 33.0878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11686_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCount);
export default __webpack_public_path__ + "static/media/users_count.479ee55123008a2fde8931a2d3c80be6.svg";
export { ForwardRef as ReactComponent };